import React from "react";

import { reject, uniqBy } from "lodash/fp";

import { FormControlLabel } from "@mui/material";

import useTranscriptStore from "@app/analytics/MeetingReport/stores/transcript";
import * as Events from "@app/analytics/MeetingReport/tracking/events";
import { areSpeakersEqual } from "@app/analytics/MeetingReport/utils";
import type { TranscriptSpeaker } from "@app/common/types";

import Checkbox from "@rui/Checkbox";
import { Column } from "@rui/Stack";

const SpeakerFilters = () => {
  const { allSpeakers, filteredSpeakers, setFilteredSpeakers } =
    useTranscriptStore((state) => ({
      allSpeakers: state.allSpeakers,
      filteredSpeakers: state.filteredSpeakers,
      setFilteredSpeakers: state.setFilteredSpeakers,
    }));

  const handleToggleSpeaker =
    (speaker: TranscriptSpeaker) =>
    (_e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      if (checked) {
        Events.filterTranscriptBySpeakers();
        const newFilteredSpeakers = uniqBy("name", [
          ...filteredSpeakers,
          speaker,
        ]);
        setFilteredSpeakers(newFilteredSpeakers);
      } else {
        setFilteredSpeakers(
          reject(areSpeakersEqual(speaker), filteredSpeakers)
        );
      }
    };

  return (
    <Column pl={1}>
      {allSpeakers.map((speaker) => {
        const isChecked = Boolean(
          filteredSpeakers.find((s) => s.name === speaker.name)
        );
        return (
          <FormControlLabel
            key={speaker.name}
            control={
              <Checkbox
                checked={isChecked}
                onChange={handleToggleSpeaker(speaker)}
              />
            }
            label={speaker.name}
          />
        );
      })}
    </Column>
  );
};

export default SpeakerFilters;
